import React from "react";
import { formatCurrency } from "../utils/format";

const SkeletonRow = () => (
  <tr className="border-b border-slate-100">
    <td className="py-2.5"><div className="h-3.5 bg-slate-100 rounded animate-pulse w-32" /></td>
    <td className="py-2.5"><div className="h-3.5 bg-slate-100 rounded animate-pulse w-16 ml-auto" /></td>
  </tr>
);

const CostTable = ({ data, loading, overrideNoTag }) => {
  if (loading) {
    return (
      <table className="w-full text-sm">
        <tbody>
          {Array.from({ length: 5 }).map((_, i) => <SkeletonRow key={i} />)}
        </tbody>
      </table>
    );
  }

  if (!data) return <p className="text-slate-400 text-sm py-8 text-center">No data</p>;

  const updatedBreakdown = data.breakdown.map(item => {
    if (item.name === "No Tag Value" && overrideNoTag) {
      return {
        ...item,
        cost: overrideNoTag // ✅ override here
      };
    }
    return item;
  });

  return (
    <div className="overflow-auto max-h-80">
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-white">
          <tr className="border-b border-slate-200 text-slate-500">
            <th className="text-left py-2 font-semibold text-xs uppercase tracking-wide">Name</th>
            <th className="text-right py-2 font-semibold text-xs uppercase tracking-wide">Cost</th>
          </tr>
        </thead>

        <tbody>
          {updatedBreakdown.map((item, index) => (
            <tr key={index} className="border-b border-slate-100 hover:bg-slate-50">
              <td className="py-2 text-slate-700">{item.name}</td>
              <td className="text-right py-2 text-slate-900 font-medium tabular-nums">
                {formatCurrency(item.cost)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CostTable;
